import type { JSX } from "react";

import { CollapseExpandButton } from "../CollapseExpandButton";
import {
    SectionBackgroundVariant,
    SectionHeader,
    SectionLevel,
} from "../Section";

import * as theme from "./SectionHeaderWithCollapse.css";

interface SectionHeaderWithCollapseProps {
    collapsed?: boolean;
    handleCollapse: () => void;
    titleLabel: React.ReactNode;
    subtitleLabel?: React.ReactNode;
    level: SectionLevel;
    backgroundVariant?: SectionBackgroundVariant;
    hideBorder?: boolean;
    /** Also stops the header from toggling. */
    hideButton?: boolean;
    rightChildren?: JSX.Element;
}

export function SectionHeaderWithCollapse({
    collapsed = false,
    handleCollapse,
    titleLabel,
    subtitleLabel,
    level,
    rightChildren,
    backgroundVariant = "default",
    hideBorder = false,
    hideButton = false,
}: SectionHeaderWithCollapseProps): JSX.Element {
    const collapseButton = (
        <div className={theme.collapsibleHeader}>
            {rightChildren !== undefined && rightChildren}
            <CollapseExpandButton
                collapsed={collapsed}
                onClick={handleCollapse}
            />
        </div>
    );

    return (
        <SectionHeader
            rightChildren={hideButton ? rightChildren : collapseButton}
            titleLabel={titleLabel}
            subtitleLabel={subtitleLabel}
            level={level}
            backgroundVariant={backgroundVariant}
            showBorder={!hideBorder && !collapsed}
            bottomBorderRadius={collapsed}
            onClick={hideButton ? undefined : handleCollapse}
        />
    );
}
